import type { TeamCapability } from '@aegislab/shared';
import { getViewState, liveWindowSize, teaserWindowSize, type WindowConfig } from '@/shared/config';
import { ViewGate } from './windowRegistryComponents';
import { lazyWindow } from './lazyWindow';

const CampaignBonusPage = lazyWindow('캠페인 성과급', () =>
  import('@/pages/CampaignBonusPage').then((m) => ({ default: m.CampaignBonusPage }))
);

/**
 * 캠페인 성과급 창 — 내 몫·내 적립 내역·팀 결산. 지금은 dev·베타 팀을 포함해 hidden 이다
 * (이강주 2026-11-02). 팀 결산의 경계는 서버가 진다.
 * `windowRegistry.tsx` 가 길이 한도에 닿아 따로 뒀다.
 */
export function buildCampaignBonusWindow(teamCapabilities: TeamCapability[]): WindowConfig {
  const state = getViewState('campaign-bonus', teamCapabilities);
  return {
    id: 'campaign-bonus',
    title: state !== 'live' ? '[DECRYPTING...]' : '캠페인 성과급',
    defaultX: 160,
    defaultY: 60,
    ...(state !== 'live' ? teaserWindowSize : liveWindowSize.wiki),
    render: () => (
      <ViewGate viewId="campaign-bonus" viewLabel="캠페인 성과급">
        <CampaignBonusPage />
      </ViewGate>
    ),
  };
}
